export const API_URL = "https://admin.booktable.co.in/api/";
// export const API_URL = "http://localhost:3010/api/";